export const AUTH_ERRORS = {
    INVALID_CREDENTIALS: 'Invalid credentials',
    INSUFFICIENT_AUTHENTICATION: 'Unable to login using that method. Your organisation has limited which methods are available for logging in and you may need to use an alternate method.',
    NO_ACCOUNTS_AVAILABLE: "You don't have administrative privileges on any accounts",
    USER_LOCKED_OUT: "Your user account has been locked out after too many failed login attempts. Please try again later or click the 'Forgot password' link below to reset your password."
  }
